<template>
  <section id="selectionScreen">
    <div class="container">
      <CancelButton></CancelButton>
      <div class="textCopy">
        <h5>Let's get started...</h5>
        <h4>Choose the card that's right for you</h4>
        <p class="is-hidden-mobile">All of our loyalty cards give you great discounts and benefits when you shop with us. We’ve tailored some of the offerings based on specific needs, you just need to choose the one that’s right for you. </p>
      </div>
      <div class="columns is-centered">
        <div class="column is-one-third">

          <a class="choiceCard bussiness" @click.stop.prevent="setApplicationState('business')">
            <img src="img/shaves_business.svg" alt>
          </a>

          <div class="choiceItem collapse">
            <div class="choiceItemTitle" @click="e => e.target.parentNode.parentNode.classList.toggle('collapse')">
               <p class="is-hidden-tablet showMore button is-small">Read More</p>
               <p class="is-hidden-tablet showLess button is-small">Hide</p>
            </div>
            <div class="choiceItemBody">
              <p>For professional and trade customers</p><br class="is-hidden-mobile">
              <ul>
                <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
             <p>Get <strong>tailored discounts</strong> on purchases</p>
            </li>
            <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
              <p>Get <strong>guidance and support</strong> from one of our dedicated reps, on products and specifications for your projects</p>
            </li>
            <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
             <p>Access an accurate <strong> record of previous </strong> purchases</p>
            </li>
                <!-- <li>
                  <span class="icon">
                    <i class="fas fa-chevron-right"></i>
                  </span>
                  Regular updates and e-magazines
                </li> -->
              </ul>
            </div>
          </div>
        </div>



        <div class="column is-one-third">
          <a class="choiceCard personal" @click.stop.prevent="setApplicationState('personal')">
            <img src="img/shaves_improver.svg" alt>
          </a>
          <div class="choiceItem collapse">
            <div class="choiceItemTitle" @click="e => e.target.parentNode.parentNode.classList.toggle('collapse')">
               <p class="is-hidden-tablet showMore button is-small">Read More</p>
               <p class="is-hidden-tablet showLess button is-small">Hide</p>
            </div>
            <div class="choiceItemBody">
              <p>For anyone painting, renovating or decorating their space</p><br class="is-hidden-mobile">
              <ul>
                <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
              <p><strong>Enjoy instant discounts</strong> of up to <strong>5%</strong> with your Shaves Home Improver Card</p>
            </li>
            <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
              <p>Get access to <strong>exclusive benefits</strong></p>
            </li>
            <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
              <p>Access an accurate <strong>record of previous</strong> purchases</p>
            </li>
                <!-- <li>
                  <span class="icon">
                    <i class="fas fa-chevron-right"></i>
                  </span>
                  Regular updates and e-magazines
                </li> -->
              </ul>
            </div>
          </div>
        </div>


        <div class="column is-one-third">
          <a class="choiceCard pensioner" @click.stop.prevent="setApplicationState('pensioner')">
            <img src="img/shaves_pensioner.svg" alt>
          </a>

          <div class="choiceItem collapse">
            <div class="choiceItemTitle" @click="e => e.target.parentNode.parentNode.classList.toggle('collapse')">
              <p class="is-hidden-tablet showMore button is-small">Read More</p>
               <p class="is-hidden-tablet showLess button is-small">Hide</p>
            </div>
            <div class="choiceItemBody">
              <p>For our customers over 60</p><br class="is-hidden-mobile">
              <ul>
                <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
              <p><strong>Enjoy instant discounts</strong> of up to <strong>5%</strong> with your Shaves Pensioner Card</p>
            </li>
            <li>
              <span class="icon">
                <i class="fas fa-chevron-right"></i>
              </span>
             <p>Access an accurate <strong>record of previous</strong> purchases</p>
            </li>
                <!-- <li>
                  <span class="icon">
                    <i class="fas fa-chevron-right"></i>
                  </span>
                  Regular updates and e-magazines
                </li> -->
              </ul>
            </div>
          </div>
        </div>
      </div>
      <div>
      <p>Whether you are a Home Improver, Pensioner or B2B customer your data is available in all our branches.</p>
      </div>
    </div>
  </section>
</template>


<script>
import CancelButton from "../components/actions/CancelButton";
export default {
  name: "selection",
  components: {
    CancelButton
  },

  data() {
    return {
     toggleOpen:false

    }
  },

  methods: {
    setApplicationState(selection) {
      this.$gtag.event('account_signup', {
        'event_category': 'engagement',
        'event_label': selection + ' Sign Up',
        'value': ''
      });
      this.$store.commit("setApplicationChoice", selection);
      if (selection == "business") {
        this.$router.push("/businessDisclaimer");
        return;
      }
      this.$router.push("/info");
    },
    clearBodyClasses() {
      document.body.classList.remove("isBusiness", "isPensioner", "isPersonal", "animateCards", "invalidField");
    },

    toggleShowClass(e){
    this.toggleOpen = e

    }
  },
  mounted() {
    this.$store.commit("resetStateProperties");
    this.clearBodyClasses();
    document.body.classList.add('animateCards');
  }

};
</script>
